import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class ColorInput extends TextInput {}

registerCustomElement('imt-input-color', ColorInput);
